import axios from "axios";
import store from "@/store";

export default {
  state: {
    trainerTransactionsHistory: [],
    trainerEarnings: [],
    trainerPayoutsHistory: [],
    trainerTransactionsByusers: [],
    trainerTransactionsBysessions: [],
    trainerZoomAuthentication: [],
    zoomDisconnect: [],
    trainerYearlyEarnings: [],
    zoomSignature: [],
    disconnectStripe: []
  },
  getters: {
    disconnectStripe(state) {
      return state.disconnectStripe
    },
    zoomSignature(state) {
      return state.zoomSignature
    },
    trainerYearlyEarnings(state) {
      return state.trainerYearlyEarnings
    },
    zoomDisconnect(state) {
      return state.zoomDisconnect
    },
    trainerTransactionsHistory(state) {
      return state.trainerTransactionsHistory;
    },
    trainerPayoutsHistory(state) {
      return state.trainerPayoutsHistory;
    },
    trainerEarnings(state) {
      return state.trainerEarnings;
    },
    trainerTransactionsByusers(state) {
      return state.trainerTransactionsByusers;
    },
    trainerTransactionsBysessions(state) {
      return state.trainerTransactionsBysessions;
    },
    trainerZoomAuthentication(state) {
      return state.trainerZoomAuthentication
    }
  },
  actions: {
    async getTrainerTransactionsHistory({ commit }, { payload, query }) {
      commit('loadingStatus', true)
      const res = await axios.post("trainer/transactions", payload, {
        params: query,
      });

      const newData = res.data.data;
      commit("setTrainerTransactionHistory", newData);
      commit('loadingStatus', false)
    },

    async getTrainerPayoutsHistory({ commit }, { payload, query }) {
      commit('loadingStatus', true)
      const res = await axios.post("trainer/transactions/payout", payload, {
        params: query,
      });

      const newData = res.data.data;
      commit("setTrainerPayoutHistory", newData);
      commit('loadingStatus', false)
    },

    async postTrainerTransactionsByusers({ commit }, { payload, query }) {
      commit('loadingStatus', true)
      const res = await axios.post("trainer/transactions/byusers", payload, {
        params: query,
      });

      const data = res.data;
      commit("setTrainerTransactionsByusers", data);
      commit('loadingStatus', false)
    },

    async postTrainerTransactionsBysessions({ commit }, { payload, query }) {
      commit('loadingStatus', true)
      const res = await axios.post("trainer/transactions/bysessions", payload, {
        params: query,
      });

      const data = res.data;
      commit("setTrainerTransactionsBysessions", data);
      commit('loadingStatus', false)
    },

    async getTrainerEarnings({ commit }, data) {
      const res = await axios.post("trainer/myearnings", data);
      const newData = res.data.data;
      if (data.filter_type == "custom") {
        newData.yearOrMonth =
          data.end_date.split("-")[1] == data.start_date.split("-")[1] && data.end_date.split("-")[0] == data.start_date.split("-")[0] ? "custom_month" : data.end_date.split("-")[0] == data.start_date.split("-")[0] ? "custom_year" : "cross_year";
        newData.start_date = data.start_date;
        newData.end_date = data.end_date;
      } else {
        newData.yearOrMonth = data.filter_type; // adding yearOrMonth filter so we know in future which request it is
        newData.year = data.start_date.split("-")[0];
      }
      commit("setTrainerEarnings", newData);
    },

    async postTrainerZoomAuthentication({ commit }, payload) {
      try {
        const res = await axios.post("trainer/zoom-authentication", payload);
        store.commit('setIsLoading', false)
        store.commit("setIsSuccess", "Successfully connected to your Zoom account");
        const data = res.data;
        commit("setTrainerZoomAuthentication", data);
      } catch(err) {
        store.commit('setIsLoading', false)
        store.commit('setError', {title: "Alert", text: err.response && err.response.data.message || err.message})
      }
    },

    async postZoomDisconnect({ commit }, payload) {
      const res = await axios.post("trainer/disconnect-zoom", payload);

      store.commit("setIsSuccess", "Successfully Disconnected to your zoom account");

      const data = res.data;
      commit("setZoomDisconnect", data);
    },

    async postDisconnectStripe({ commit }, payload) {
      const res = await axios.post("trainer/disconnect-stripe", payload);

      store.commit("setIsSuccess", "Successfully Disconnected to your stripe account");

      const data = res.data;
      commit("setDisconnectStripe", data);
    },

    async getTrainerYearlyEarnings({ commit }, payload) {
      const res = await axios.get("trainer/yearly-earnings");

      const data = res && res.data && res.data.data;
      commit("setTrainerYearlyEarnings", data);
    },

    async postZoomSignature({ commit }, payload) {
      const res = await axios.post("zoom-signature", payload);

      const data = res && res.data;
      commit("setZoomSignature", data);
    },
  },

  mutations: {
    setZoomSignature(state, data) {
      state.zoomSignature = data
    },
    setTrainerYearlyEarnings(state, data) {
      state.trainerYearlyEarnings = data;
    },
    setTrainerTransactionHistory(state, data) {
      state.trainerTransactionsHistory = data;
    },
    setTrainerPayoutHistory(state, data) {
      state.trainerPayoutsHistory = data;
    },
    setTrainerTransactionsByusers(state, data) {
      state.trainerTransactionsByusers = data;
    },
    setTrainerTransactionsBysessions(state, data) {
      state.trainerTransactionsBysessions = data;
    },
    setTrainerZoomAuthentication(state, data) {
      const user = JSON.parse(localStorage.getItem("user"));
      user.zoomAuthorized = user.zoomAuthorized == 1 ? 0 : 1;
      const newUser = JSON.stringify(user);
      localStorage.setItem("user", newUser);
      state.trainerZoomAuthentication = data
    },
    setZoomDisconnect(state, data) {
      const user = JSON.parse(localStorage.getItem("user"));
      user.zoomAuthorized = user.zoomAuthorized == 1 ? 0 : 1;
      const newUser = JSON.stringify(user);
      localStorage.setItem("user", newUser);
      state.zoomDisconnect = data
    },
    setDisconnectStripe(state, data) {
      state.disconnectStripe = data
    },
    setTrainerEarnings(state, data) {
      let monthInYear = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      let arr = [];
      let year = "";
      //if overall amout is zero
      if (data.total_earned[0].amount != 0 && data.total_earned[0].amount != null) {
        //if user selected month
        if ((data.yearOrMonth == "month" || data.yearOrMonth == "custom_month") && data.total_earned_chart.length > 0) {
          year = data && data.total_earned_chart && data.total_earned_chart[0] && data.total_earned_chart[0].label && data.total_earned_chart[0].label.split(" ")[2];
          let leapOrNot = (year % 4 == 0 && year % 100 != 0) || year % 400 == 0;

          let obj = {
            January: 31,
            February: leapOrNot ? 29 : 28,
            March: 31,
            April: 30,
            May: 31,
            June: 30,
            July: 31,
            August: 31,
            September: 30,
            October: 31,
            November: 30,
            December: 31,
          };
          let start_of_loop = 0;
          let end_of_loop = 0;
          let currentMonth = data && data.total_earned_chart && data.total_earned_chart[0] && data.total_earned_chart[0].label && data.total_earned_chart[0].label.split(" ")[1];
          //Here we will check if the request is custom or not if custom we have to set start and end of loop
          if (data.yearOrMonth == "custom_month") {
            start_of_loop = parseInt(data.start_date.split("-")[2]);
            end_of_loop = parseInt(data.end_date.split("-")[2]);
          }
          else {
            start_of_loop = 1;
            end_of_loop = obj[currentMonth];
          }
          while (start_of_loop <= end_of_loop) {
            let found = false;
            let j = 0;
            while (j < data.total_earned_chart.length) {
              if (start_of_loop == data.total_earned_chart[j].label.split(" ")[0]) found = true;
              if (found) {
                data.total_earned_chart[j].label =
                  data.total_earned_chart[j].label.split(" ")[0] +
                  " " +
                  data.total_earned_chart[j].label.split(" ")[1] + ` ${year}`;
                arr.push(data.total_earned_chart[j]);
                break;
              }
              j++;
            }
            if (!found) {
              let date = start_of_loop > 9 ? start_of_loop : "0" + start_of_loop;
              let obj = {
                amount: "0.00",
                label: `${date}` + ` ${currentMonth} ` + `${year}`,
              };
              arr.push(obj);
            }
            start_of_loop++
          }
          data.total_earned_chart = arr;
        }
        //If user selected the year
        else if ((data.yearOrMonth == "year" || data.yearOrMonth == "custom_year") && data.total_earned_chart.length > 0) {


          let start_of_loop = 0;
          let end_of_loop = 0;
          //Here we will check if the request is custom or not if custom we have to set start and end of loop
          if (data.yearOrMonth == "custom_year") {
            start_of_loop = parseInt(data.start_date.split("-")[1]) - 1;
            end_of_loop = parseInt(data.end_date.split("-")[1]);
            year = data.start_date.split("-")[0];
          }
          else {
            start_of_loop = 0;
            end_of_loop = 12;
            year = data.year;

          }

          while (start_of_loop < end_of_loop) {
            let found = false;
            let j = 0;
            while (j < data.total_earned_chart.length) {

              if (monthInYear[start_of_loop] == data.total_earned_chart[j].label.split(" ")[0])
                found = true;

              if (found) {
                data.total_earned_chart[j].label = data.total_earned_chart[j].label.split(" ")[0] + ` ${year}`;
                arr.push(data.total_earned_chart[j]);
                break;
              }
              j++;
              //end of inner while loop
            }
            if (!found) {
              let obj = {
                amount: "0.00",
                label: `${monthInYear[start_of_loop]} ` + `${year}`,
              };
              arr.push(obj);
            }
            start_of_loop++;
          }
          data.total_earned_chart = arr;
        }
        else if (data.yearOrMonth == "cross_year") {
          let start_of_year_loop = parseInt(data.start_date.split("-")[0]);
          let end_of_year_loop = parseInt(data.end_date.split("-")[0]);
          let end_of_month_loop = 12;

          while (start_of_year_loop <= end_of_year_loop) {
            let start_of_month_loop = parseInt(data.start_date.split("-")[1]) - 1;
            if (start_of_year_loop == end_of_year_loop) {
              end_of_month_loop = parseInt(data.end_date.split("-")[1]);
              start_of_month_loop = 0;

            }

            while (start_of_month_loop < 12 && start_of_month_loop < end_of_month_loop) {
              let comparingLabelString = monthInYear[start_of_month_loop] + " " + start_of_year_loop;
              let found = false;
              let j = 0;
              while (j < data.total_earned_chart.length) {
                if (comparingLabelString == data.total_earned_chart[j].label) found = true;
                if (found) {
                  data.total_earned_chart[j].label = comparingLabelString;
                  arr.push(data.total_earned_chart[j]);
                  break;
                }
                j++;
              }
              if (!found) {
                let obj = {
                  amount: "0.00",
                  label: comparingLabelString,
                };
                arr.push(obj);
              }
              start_of_month_loop++;
            }
            start_of_year_loop++;
          }
          data.total_earned_chart = arr;

        }
      }
      else {
        data.total_earned_chart = [];
      }
      state.trainerEarnings = data;
    },
  },
};